class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.querySelector('.deferred-media__poster-button').style.display = 'none';
      this.setAttribute('loaded', true);
      return this.appendChild(content.querySelector('video, model-viewer, iframe'));
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

//Stop media on scroll
window.onscroll = function() {
const eleIsVisibleInViewport = (el, partiallyVisible = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};
//eleIsVisibleInViewport(el); // false - (not fully visible)
//eleIsVisibleInViewport(el, true); // true - (partially visible)
  var videos = document.querySelectorAll('.product-media-mobile-only video, .product-media-mobile-only iframe');
   if(videos != null){
    videos.forEach(function(video){
        if(video.tagName == 'VIDEO'){
          if(eleIsVisibleInViewport(video, true) == false){
            video.pause();
          }
        } else if(video.tagName == 'IFRAME') {
          if(eleIsVisibleInViewport(video, true) == false){
            video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
          }
        }
    });
   }
}
